// src/data/adminDraftRead.js
//
// RULING 66 (Record 582): "Every administrative read of a draft is written to the audit collection."
// firestore.rules refuses the administrator a direct read of another person's draft claim or draft discipline
// case. The only door is the callable adminReadDraft (functions\index.js), which writes an audit_logs entry
// (action 'admin_draft_read') and returns the draft. This module calls it and revives its timestamps.
import { getFunctions, httpsCallable } from 'firebase/functions';
import { Timestamp } from 'firebase/firestore';

export function reviveTimestamps(v) {
  if (Array.isArray(v)) return v.map(reviveTimestamps);
  if (v && typeof v === 'object') {
    const keys = Object.keys(v);
    if (keys.length === 1 && keys[0] === '__ts' && typeof v.__ts === 'string') return Timestamp.fromDate(new Date(v.__ts));
    const o = {};
    for (const k of keys) o[k] = reviveTimestamps(v[k]);
    return o;
  }
  return v;
}

// True only for an administrator whose direct read was refused - the case the callable exists for.
export function shouldTryAuditedRead(user, err) {
  const admin = !!(user && (user.isAdmin || user.role === 'admin'));
  const code = err && (err.code || '');
  return admin && /permission-denied/.test(String(code));
}

// kind: 'claim' | 'discipline'. Resolves { id, ...data, auditedDraftRead: true }.
export async function adminReadDraft(kind, id) {
  const fn = httpsCallable(getFunctions(), 'adminReadDraft');
  const r = await fn({ kind, id });
  const data = reviveTimestamps((r && r.data && r.data.data) || {});
  return { id, ...data, auditedDraftRead: true };
}
